<template>
  <div class="h-panel-body padding font-bold check-wrap">
    <!-- 无数据兜底 -->
    <div v-if="years.length === 0" class="empty-tip">暂无结账周期数据</div>

    <template v-else>
      <h2
          class="year-title"
          v-for="year in years"
          :key="year"
      >
        <span class="year-text">{{ year }} 年</span>
        <Row :space="20" class="month-row">
          <Cell
              v-for="month in dataList[year]"
              :key="year + month.checkMonth"
              width="4"
          >
            <div
                class="period-card"
                :class="{
                disable: month.disable,
                completed: month.status === 2
              }"
                @click="carryForward(month)"
            >
              <!-- 顶部状态条 -->
              <div class="card-header">
                <i
                    v-if="month.status === 2"
                    class="fa fa-lock lock-icon"
                ></i>
              </div>
              <!-- 月份文字 -->
              <div class="month-text">{{ month.checkMonth }}月</div>
            </div>
          </Cell>
        </Row>
      </h2>
    </template>
  </div>
</template>

<script>
export default {
  name: "CheckList",
  data() {
    return {
      dataList: {}
    };
  },
  computed: {
    years() {
      return Object.keys(this.dataList).sort((a, b) => b - a);
    }
  },
  methods: {
    loadList() {
      this.$api.checkout.list().then(({ data }) => {
        let disable = false;
        // 倒序标记不可操作状态
        for (let i = data.length - 1; i >= 0; i--) {
          data[i].disable = disable;
          if (data[i].status === 0) {
            disable = true;
          }
        }

        // 按年份分组
        const checkData = {};
        data.forEach((val) => {
          if (!checkData[val.checkYear]) {
            checkData[val.checkYear] = [];
          }
          checkData[val.checkYear].push(val);
        });

        this.dataList = checkData;
      });
    },
    carryForward(data) {
      if (data.status === 0 && !data.disable) {
        this.$router.push({ name: "CarryForward", params: data });
      } else if (data.disable) {
        this.$Message.warning("上期未结账，本期不能结账");
      }
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
.check-wrap {
  .empty-tip {
    text-align: center;
    padding: 60px 0;
    font-size: 15px;
    color: #999;
  }

  .year-title {
    margin: 0 0 24px 0;
    .year-text {
      display: inline-block;
      font-size: 20px;
      color: #262626;
      margin-bottom: 12px;
      padding-left: 4px;
      border-left: 4px solid @primary-color;
      line-height: 1;
    }

    .month-row {
      margin-bottom: 16px;
    }
  }

  // 月份卡片基础样式
  .period-card {
    border-radius: 8px;
    text-align: center;
    border: 1px solid @primary-color;
    height: 86px;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    transition: all 0.24s ease;

    // 顶部状态栏
    .card-header {
      height: 26px;
      background-color: @primary-color;
      display: flex;
      align-items: center;
      justify-content: center;

      .lock-icon {
        color: #fff;
        font-size: 14px;
      }
    }

    .month-text {
      height: calc(100% - 26px);
      line-height: 60px;
      font-size: 20px;
      color: #222;
      font-weight: 500;
    }

    // 可点击hover效果
    &:hover:not(.disable):not(.completed) {
      cursor: pointer;
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(@primary-color, 0.18);
    }

    // 已结账完成状态
    &.completed {
      border-color: @gray1-color;
      .card-header {
        background-color: @gray1-color !important;
      }
      .month-text {
        color: #a2a2a2;
      }
      cursor: default;
      box-shadow: none;
      transform: none;
    }

    // 不可操作置灰状态
    &.disable {
      opacity: 0.42;
      cursor: not-allowed;
      box-shadow: none;
      transform: none;
    }
  }
}
</style>